import type { VoiceProfile } from "../types/app";

export function clampVoiceProfile(profile: VoiceProfile): VoiceProfile {
  const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);
  return {
    ...profile,
    pitch: clamp(profile.pitch, 0.5, 1.8),
    rate: clamp(profile.rate, 0.5, 1.4),
    gain: clamp(profile.gain, 0, 1.5),
    warmth: clamp(profile.warmth, 0, 1),
    brightness: clamp(profile.brightness, 0, 1),
    softness: clamp(profile.softness, 0, 1),
    breathiness: clamp(profile.breathiness, 0, 1),
    compression: clamp(profile.compression, 0, 1),
    reverb: clamp(profile.reverb, 0, 1),
    pauseLength: clamp(profile.pauseLength, 0, 1.5),
  };
}
